import Vue from 'vue';
import Router from 'vue-router';
import History from './views/history/History.vue';
import TechnicalAlarm from './views/technicalAlarm/TechnicalAlarm.vue';
import Statistics from './views/Statistics/Statistics.vue';
import Login from '@/views/Login.vue';
import DefaultContainer from '@/views/DefaultContainer.vue';
import PageNotFound from '@/views/404.vue';
import MyProfile from '@/views/me/MyProfile.vue';
import Users from '@/views/Users.vue';
import Agencies from '@/views/Agencies.vue';
import Residencies from '@/views/Residencies.vue';
import AuthLogs from '@/views/AuthLogs.vue';

Vue.use(Router);

export const createRouter = (kuzzle: any, store: any) => {
  const authenticationGuard = async (to: any, from: any, next: any) => {
    try {
      if (await store.dispatch('auth/CHECK_TOKEN', kuzzle)) {
        next();
      } else {
        next({ name: 'login', query: { to: to.name } });
      }
    } catch (error) {
      console.error((error as any).message);
      next({ name: 'login', query: { to: to.name } });
    }
  };

  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/login',
        name: 'login',
        component: Login,
      },
      {
        path: '/',
        beforeEnter: authenticationGuard,
        component: DefaultContainer,
        children: [
          {
            path: '/',
            name: 'History',
            component: History,
          },
          {
            path: '/statistics',
            name: 'Statistics',
            component: Statistics,
          },
          {
            path: '/technical-alarm',
            name: 'TechnicalAlarm',
            component: TechnicalAlarm,
          },
          {
            path: '/admin/users',
            name: 'users-management',
            component: Users,
          },
          {
            path: '/admin/logs/auth',
            name: 'AuthLogs',
            component: AuthLogs,
          },
          {
            path: '/platform-management/tenants',
            name: 'tenants-management',
            component: Agencies,
          },
          {
            path: '/platform-management/residencies',
            name: 'residencies-management',
            component: Residencies,
          },
          {
            path: '/me/profile',
            name: 'My Profile',
            component: MyProfile,
          },
        ],
      },
      {
        path: '*',
        component: PageNotFound,
      },
    ],
  });

  router.beforeEach(async (to, from, next) => {
    /**
     * This route guard ensures that the app is connected to Kuzzle before
     * passing to the next route.
     */
    const offlinePageDelay = 1500;
    return new Promise(async (resolve) => {
      setTimeout(() => {
        if (!store.state.app.online) {
          store.commit('app/SET_WAITING_FOR_CONNECTION');
        }
      }, offlinePageDelay);
      const onceConnected = () => {
        store.commit('app/SET_ONLINE');
        setTimeout(() => {
          store.commit('app/UNSET_WAITING_FOR_CONNECTION');
        }, offlinePageDelay);

        kuzzle.removeListener('connected', onceConnected);
        kuzzle.removeListener('reconnected', onceConnected);

        next();
        return resolve(null);
      };
      if (!store.state.app.online) {
        kuzzle.addListener('connected', onceConnected);
        kuzzle.addListener('reconnected', onceConnected);
      } else {
        onceConnected();
      }
    });
  });

  return router;
};
